import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiBaseUrl } from "../commonUtils/commonUtils.js";

const baseQuery = fetchBaseQuery({
  baseUrl: apiBaseUrl + "/",
  prepareHeaders: (headers, { getState }) => {
    const accessToken = getState().loginAuthReducer?.authToken;
    if (accessToken) {
      headers.set("Authorization", `Bearer ${accessToken}`);
    } else {
      const isAuthenticated = localStorage.getItem("accessToken");
      if (isAuthenticated) {
        headers.set("Authorization", `Bearer ${isAuthenticated}`);
      }
    }

    const selectedCity =
      getState().loginAuthReducer?.selectedCity ||
      localStorage.getItem("selectedCity");
    const normalizedCity = selectedCity?.trim();
    if (normalizedCity && normalizedCity.toLowerCase() !== "all") {
      headers.set("x-city", normalizedCity);
    }
    return headers;
  },

  // timeout: 15000,
});
const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result?.error && result?.error?.status === 401) {
    localStorage.clear();
  }
  return result;
};
const loginBaseQuery = fetchBaseQuery({
  baseUrl: apiBaseUrl + "/",
  // timeout: 15000,
});

export { baseQuery, loginBaseQuery, baseQueryWithReauth };
